import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthorizeRequest } from 'src/app/model/api/api-request/authorize-request';
import { AuthorizeWithStateRequest } from 'src/app/model/api/api-request/authorize-with-state-request';
import { GetTokenFromCookieRequest } from 'src/app/model/api/api-request/get-token-from-cookie-request';
import { AuthorizationResult } from 'src/app/model/interfaces/authorization-result';
import { JWT } from 'src/app/model/interfaces/json-web-token';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ApiClient } from '../api-client/api-client';

@Injectable({ providedIn: 'root' })
export class AuthorizationRepository
{

    private readonly apiClient: ApiClient;
    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
    }

    public authorize(username: string, password: string): Observable<AuthorizationResult>
    {
        const webapiBasepath = this.environment.config['sitecoreapipath'];
        const request = new AuthorizeRequest(username, password, webapiBasepath);
        return this.apiClient.post(request);
    }

    public authorizeWithState(state: string): Observable<JWT>
    {
        const webapiBasepath = this.environment.config['sitecoreapipath'];
        const request = new AuthorizeWithStateRequest(state, webapiBasepath);
        return this.apiClient.get<JWT>(request);
    }

    public getTokenFromCookie(): Observable<JWT>
    {
        const webapiBasepath = this.environment.config['sitecoreapipath'];
        const request = new GetTokenFromCookieRequest(webapiBasepath);
        return this.apiClient.get<JWT>(request);
    }
    
}
